<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button>
                         <el-input
                            size="small"
                            style="width:300px;margin-left:30px;"
                            placeholder="请输入标题"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                            prop="Title"
                            label="标题"
                            width="300px">
                        </el-table-column>
                        <el-table-column
                            prop="Context"
                            label="内容">
                        </el-table-column>
                        <el-table-column
                            prop="PublisherName"
                            width="100px"
                            label="发布人">
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            width="160"
                            label="发布时间">
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="80px">
                            <template slot-scope="scope">
                                <el-button type="danger" size="mini" @click="del(scope.row)"  icon="el-icon-delete" circle></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="添加公告" :visible.sync="dialogFormVisible" width="400px">
            <el-form :model="newModel"  :rules="rules" ref="ruleForm" label-width="80px">
                <el-form-item label="标题：" prop="Title">
                    <el-input placeholder="请输入公告标题" v-model="newModel.Title"></el-input>
                </el-form-item>
                <el-form-item label="内容：" prop="Context">
                    <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入公告内容"
                    v-model="newModel.Context">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { announcementGet,announcementDel,announcementAdd} from '@/request.js'

export default {
    data(){
        return {
            dialogFormVisible:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
            },
            tableData:[],
            newModel:{
                Id:0,
                Title:"",
                Context:"",
            },
            rules: {
                Title: [
                    { required: true, message: '请填写公告标题', trigger: 'blur' },
                    { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
                ],
                Context: [
                    { required: true, message: '请填写公告内容', trigger: 'blur' },
                ],
            }
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
       
    },
    methods: {
        submitForm() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    announcementAdd(this.newModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.dialogFormVisible=false;
                            this.query();
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        add(){
            this.newModel={
                Id:0,
                Title:"",
                Context:"",
            };
            this.dialogFormVisible=true;
        },
        del(scope){
            this.$confirm('确认删除该公告吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                announcementDel({id:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.tableData.forEach((item, index, arr)=>{
                            if(item==scope){
                                arr.splice(index, 1);
                            }
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        query(){
            this.isLoading=true;
            announcementGet(this.queryModel,(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>